import React, {useEffect, useState} from "react";
import {FilePond, registerPlugin} from "react-filepond";
import {FilePondErrorDescription, FilePondFile} from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

import {ButtonComponent} from "./button.component";

import {observer} from "mobx-react-lite";

interface UploadComponentProps
{
    updateFilesFunction: ( files: FilePondFile[] ) => void
    onRemoveFileFunction?: ( error: FilePondErrorDescription | null, file: FilePondFile ) => void;
    allowedFileTypes: string[]
    text: string
}

export const UploadComponent = observer( ( {updateFilesFunction, onRemoveFileFunction, allowedFileTypes, text}: UploadComponentProps ) => {
    registerPlugin( FilePondPluginFileValidateType )

    return (
        <FilePond
            onupdatefiles={updateFilesFunction}
            onremovefile={onRemoveFileFunction}
            allowMultiple={true}
            acceptedFileTypes={allowedFileTypes}
            maxFiles={10}
            name="files"
            labelIdle={text}
        />
    )
} );

interface SubmitUploadButtonProps
{
    text: string
    theme: string
    uploadFunction: ( files: FilePondFile[] ) => Promise<void>
    files: FilePondFile[]
}

export const SubmitUploadButton = observer( ( {uploadFunction, files, text, theme}: SubmitUploadButtonProps ) => {
    const [disabled, setDisabled] = useState( true );

    useEffect( () => {
        if ( files.length != 0 ) {
            setDisabled( false )
        }
    }, [files] )

    return (<ButtonComponent
        disabled={disabled}
        additionalCssClasses={["btn-inverted"]}
        text={text}
        onClick={() => uploadFunction( files )}
        theme={theme}
        type={"primary"}
    />)
} );

